import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2454425c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notfound" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "page not found", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("404 "),
  /*#__PURE__*/_createElementVNode("b", null, "Page"),
  /*#__PURE__*/_createTextVNode(" .")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseWrapper = _resolveComponent("BaseWrapper")!

  return (_openBlock(), _createBlock(_component_BaseWrapper, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("notfoundMsg.value")), 1),
        _createVNode(_component_BaseButton, {
          text: _ctx.$t('wakalahForm.value'),
          onOnSubmit: _ctx.goHome
        }, null, 8, ["text", "onOnSubmit"])
      ])
    ]),
    _: 1
  }))
}